module.exports = __webpack_public_path__ + "img/card_260010873.e19ad9bd.jpg";